import(/* webpackMode: "eager" */ "/vercel/path0/app/articles/how-indie-hackers-can-build-profitable-b2c-marketplaces-with-a-nextjs-boilerplate/page.tsx");
